import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MonitorX } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { useAuth } from '../contexts/AuthContext';
import { logoutAllDevices } from '../services/api';

export const SignOutEverywhereButton = ({ className = '', showLabel = false }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      await logoutAllDevices();
      toast.success('Signed out on every device.');
      setOpen(false);
      logout();
      navigate('/login');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Could not sign out everywhere');
    } finally { setBusy(false); }
  };

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)} className={className}
        title="Sign out on all devices" data-testid="sign-out-everywhere-btn">
        <MonitorX className="w-4 h-4" />
        {showLabel && <span className="ml-2">Sign out everywhere</span>}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="sign-out-everywhere-dialog">
          <DialogHeader>
            <DialogTitle>Sign out on all devices?</DialogTitle>
            <DialogDescription>Every browser and phone logged into this account, including this one, will be signed out right away.</DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} data-testid="sign-out-everywhere-cancel">Cancel</Button>
            <Button variant="destructive" onClick={confirm} disabled={busy} data-testid="sign-out-everywhere-confirm">
              {busy ? 'Signing out...' : 'Sign out everywhere'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
